export default __webpack_public_path__ + "static/media/21-min.4b798019.jpg";